import React, { Component } from "react";
import { Link } from "react-router-dom";
import classNames from "classnames";

const MenuItemImage = ({ className, ...props }) => {
  return (
    <img
      width={24}
      height={24}
      className={classNames("menu-icon", className)}
      alt=""
      {...props}
    />
  );
};

class NavMenu extends Component {
  toggleCollapse(e) {
    e.setState({
      isVisible: e.state.isVisible,
      isAdmin: e.state.isAdmin,
      isCollapsed: !e.state.isCollapsed,
    });
  }

  constructor(props) {
    super(props);

    this.state = {
      isVisible: true,
      isAdmin: true,
      isCollapsed: false,
    };
  }

  render() {
    let collapsed = this.state.isCollapsed;
    let classes = collapsed ? "collapsed" : "";

    const pathname = this.props.location.pathname;

    return (
      <nav id={this.props.id} className={classes}>
        <div className="menu-head">
          <div id="nav-toggle-button" onClick={() => this.toggleCollapse(this)}>
            <span className="menu-head-text collapsible">MENU</span>
            <MenuItemImage
              id="nav-toggle-icon-collapsed"
              hidden={!collapsed}
              src="/content/images/icon-menu-light.svg"
            />
            <MenuItemImage
              id="nav-toggle-icon"
              hidden={collapsed}
              src="/content/images/arrow-left.svg"
            />
          </div>
        </div>
        <div style={{ overflowX: "hidden", overflowY: "auto", height: "calc(100vh - 138px)" }}>
          <ul>
            <li className={classNames("menu-item", {
              selected: pathname.startsWith("/home") || pathname.startsWith("/lead-form")
            })}>
              <Link className="menu_a_link" to="/home" draggable="false">
                <div className="menu-item-wrapper">
                  <MenuItemImage
                    src="/content/images/menu-icon-home-light.svg"
                    className="menu-icon light"
                  />
                  <MenuItemImage
                    src="/content/images/menu-icon-home-dark.svg"
                    className="menu-icon dark"
                  />
                  <span className="menu-item-text collapsible">Home</span>
                </div>
              </Link>
            </li>
            {/* <li className={classNames("menu-item", {
              selected: pathname.startsWith("/appetite-search")
            })}>
              <Link className="menu_a_link" to="/appetite-search" draggable="false">
                <div className="menu-item-wrapper">
                  <MenuItemImage
                    src="/content/images/menu-icon-clients-light.svg"
                    className="menu-icon light"
                  />
                  <MenuItemImage
                    src="/content/images/menu-icon-clients-dark.svg"
                    className="menu-icon dark"
                  />
                  <span className="menu-item-text collapsible">
                    Appetite Search
                  </span>
                </div>
              </Link>
            </li> */}
            <li className={classNames("menu-item", {
              selected: pathname.startsWith("/your-clients") || pathname.startsWith("/client")
            })}>
              <Link className="menu_a_link" to="/your-clients" draggable="false">
                <div className="menu-item-wrapper">
                  <MenuItemImage
                    src="/content/images/menu-icon-clients-light.svg"
                    className="menu-icon light"
                  />
                  <MenuItemImage
                    src="/content/images/menu-icon-clients-dark.svg"
                    className="menu-icon dark"
                  />
                  <span className="menu-item-text collapsible">
                    View Clients
                  </span>
                </div>
              </Link>
            </li>
            <li className={classNames("menu-item", {
              selected: pathname.startsWith("/expiring-policies")
            })}>
              <Link className="menu_a_link" to="/expiring-policies" draggable="false">
                <div className="menu-item-wrapper">
                  <MenuItemImage
                    src="/content/images/menu-icon-view-policy-light.svg"
                    className="menu-icon light"
                  />
                  <MenuItemImage
                    src="/content/images/menu-icon-view-policy-dark.svg"
                    className="menu-icon dark"
                  />
                  <span className="menu-item-text collapsible">
                    Expiring Policies
                  </span>
                </div>
              </Link>
            </li>
            <li className={classNames("menu-item", {
              selected: pathname.startsWith("/quotes")
            })}>
              <Link className="menu_a_link" to="/quotes" draggable="false">
                <div className="menu-item-wrapper">
                  <MenuItemImage
                    src="/content/images/menu-icon-quotes-light.svg"
                    className="menu-icon light"
                  />
                  <MenuItemImage
                    src="/content/images/menu-icon-quotes-dark.svg"
                    className="menu-icon dark"
                  />
                  <span className="menu-item-text collapsible">
                    View Quotes
                  </span>
                </div>
              </Link>
            </li>
            <li className={classNames("menu-item", {
              selected: pathname.startsWith("/start-application")
            })}>
              <Link className="menu_a_link" to="/start-application" draggable="false">
                <div className="menu-item-wrapper">
                  <MenuItemImage
                    src="/content/images/menu-icon-start-app-light.svg"
                    className="menu-icon light"
                  />
                  <MenuItemImage
                    src="/content/images/menu-icon-start-app-dark.svg"
                    className="menu-icon dark"
                  />
                  <span className="menu-item-text collapsible">
                    Start New Quote
                  </span>
                </div>
              </Link>
            </li>
            <li className={classNames("menu-item", {
              selected: pathname.startsWith("/finish-application")
            })}>
              <Link className="menu_a_link" to="/finish-application" draggable="false">
                <div className="menu-item-wrapper">
                  <MenuItemImage
                    src="/content/images/menu-icon-finish-app-light.svg"
                    className="menu-icon light"
                  />
                  <MenuItemImage
                    src="/content/images/menu-icon-finish-app-dark.svg"
                    className="menu-icon dark"
                  />
                  <span className="menu-item-text collapsible">
                    Finish Quote
                  </span>
                </div>
              </Link>
            </li>
            <li className={classNames("menu-item", {
              selected: pathname.startsWith("/reference-tools")
            })}>
              <Link className="menu_a_link" to="/reference-tools" draggable="false">
                <div className="menu-item-wrapper">
                  <MenuItemImage
                    src="/content/images/menu-icon-reference-tools-light.svg"
                    className="menu-icon light"
                  />
                  <MenuItemImage
                    src="/content/images/menu-icon-reference-tools-dark.svg"
                    className="menu-icon dark"
                  />
                  <span className="menu-item-text collapsible">
                    Reference Tools
                  </span>
                </div>
              </Link>
            </li>
          </ul>
        </div>
      </nav>
    );
  }
}

export default NavMenu;
